import { render, staticRenderFns } from "./changeOrderWindow.vue?vue&type=template&id=379bb06c&scoped=true&"
import script from "./changeOrderWindow.vue?vue&type=script&lang=js&"
export * from "./changeOrderWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379bb06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379bb06c')) {
      api.createRecord('379bb06c', component.options)
    } else {
      api.reload('379bb06c', component.options)
    }
    module.hot.accept("./changeOrderWindow.vue?vue&type=template&id=379bb06c&scoped=true&", function () {
      api.rerender('379bb06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/releaseControl/changeOrderWindow.vue"
export default component.exports